var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-dropdown",
    { staticStyle: { height: "100%", "vertical-align": "initial" } },
    [
      _c(
        "span",
        { staticClass: "avatarClass", staticStyle: { cursor: "pointer" } },
        [
          _c("el-avatar", {
            staticStyle: { "margin-right": "10px" },
            attrs: { size: 25, fit: "fill", src: "/static/img/avator.png" }
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.loginName))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-menu",
        {
          staticStyle: {
            width: "150px",
            float: "right",
            "margin-right": "-10%"
          },
          attrs: { slot: "overlay" },
          slot: "overlay"
        },
        [
          _c("a-menu-item", { on: { click: _vm.logOut } }, [
            _c(
              "span",
              [
                _c("a-icon", { attrs: { type: "poweroff" } }),
                _vm._v(" "),
                _c("span", [_vm._v("退出登录")])
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5037cee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5037cee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/HeaderlAvatar.vue
// module id = null
// module chunks = 